// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a[data-v-234490c8]{fill:#24bf77}.b[data-v-234490c8]{fill:#7ac6a3}.c[data-v-234490c8]{fill:#f5f5f5}.d[data-v-234490c8]{fill:#fff3e7}.e[data-v-234490c8]{fill:#eee3d8}.f[data-v-234490c8]{fill:#3f3f3f;font-size:35px;font-family:SegoeUI-Semibold,Segoe UI;font-weight:600}", ""]);
// Exports
module.exports = exports;
